import { styled } from "@linaria/react"
import { useEffect, useState } from "react"

import { importHighlightJsStyles } from "@/styles/mixins.ts"
import * as textStyles from "@/styles/textStyles.ts"

export const CodeSnippet = (props: {
  text?: string
  language?: string | null
}) => {
  const [highlightedHtml, setHighlightedHtml] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false

    if (!props.text) {
      setHighlightedHtml(null)
      return
    }

    let cleanup: () => void | undefined

    void import("highlight.js/lib/common").then((module) => {
      if (!props.text || cancelled) return

      cleanup = importHighlightJsStyles()

      const result = props.language
        ? module.default.highlight(props.text, { language: props.language })
        : module.default.highlightAuto(props.text)

      if (!cancelled) {
        if (props.language || result.relevance > 10) {
          setHighlightedHtml(result.value)
        } else {
          setHighlightedHtml(null)
        }
      }
    })

    return () => {
      cancelled = true
      cleanup?.()
    }
  }, [props.text, props.language])

  if (!props.text) return null

  return highlightedHtml != null ? (
    <Container dangerouslySetInnerHTML={{ __html: highlightedHtml }} />
  ) : (
    <Container>{props.text}</Container>
  )
}

const Container = styled.pre`
  ${textStyles.pre};
`